var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMagnifier = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5486 20.9448C15.9457 20.9448 17.2503 20.4903 18.3108 19.7328L22.3003 23.7223C22.4854 23.9074 22.7295 24 22.982 24C23.5291 24 23.9247 23.5792 23.9247 23.0405C23.9247 22.788 23.8405 22.5523 23.6553 22.3672L19.6911 18.3945C20.5244 17.3004 21.0209 15.9453 21.0209 14.4724C21.0209 10.9122 18.1088 8 14.5486 8C10.9799 8 8.07617 10.9122 8.07617 14.4724C8.07617 18.0326 10.9799 20.9448 14.5486 20.9448ZM14.5486 19.5476C11.7627 19.5476 9.47333 17.2499 9.47333 14.4724C9.47333 11.6949 11.7627 9.39716 14.5486 9.39716C17.326 9.39716 19.6238 11.6949 19.6238 14.4724C19.6238 17.2499 17.326 19.5476 14.5486 19.5476ZM15.2303 16.9637C15.2303 17.3677 14.9021 17.6118 14.5486 17.6118C14.1951 17.6118 13.8584 17.3677 13.8584 16.9637V15.1036H12.1582C11.8132 15.1036 11.527 14.809 11.527 14.4724C11.527 14.1357 11.8132 13.8411 12.1582 13.8411H13.8584V11.9811C13.8584 11.5771 14.1951 11.333 14.5486 11.333C14.9021 11.333 15.2303 11.5771 15.2303 11.9811V13.8411H16.9305C17.2755 13.8411 17.5701 14.1357 17.5701 14.4724C17.5701 14.809 17.2755 15.1036 16.9305 15.1036H15.2303V16.9637Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMagnifier);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Magnifier.037db7e159cd9d7a6465f8892aca2832.svg";